import React, { Component } from 'react';
import { Nav, NavLink, NavItem } from 'reactstrap';
export default class Footer extends Component {
  constructor() {
    super(...arguments);
    this.getNavItem = (link, label) => {
      const div = /*#__PURE__*/React.createElement(NavItem, {
        className: "navbar-text"
      }, /*#__PURE__*/React.createElement(NavLink, {
        href: link
      }, label));
      return div;
    };
  }
  render() {
    const base = "".concat(process.env.REACT_APP_BASE_URL, "/admin").concat(process.env.REACT_APP_URL_ENV, "/projects");
    return /*#__PURE__*/React.createElement("div", {
      id: "wm_footer"
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Nav, {
      className: "navbar navbar-dark bg-dark justify-content-center"
    }, this.getNavItem(base, 'Otto Roadmap')));
  }
}